import { LIST } from '../types';
import { ResourceComp, Field } from 'src/config';

const LIST_START_QUERY = 'query/LIST_START_QUERY';
const LIST_START_INITIAL_QUERY = 'query/LIST_START_INITIAL_QUERY';
const LIST_START_EXISTING_QUERY = 'query/LIST_START_EXISTING_QUERY';
const LIST_RESPONSE = 'query/LIST_RESPONSE';
const LIST_ERROR = 'query/LIST_ERROR';
const ENTITY_START_DELETE = 'query/ENTITY_START_DELETE';
const LIST_SET_PAGE_SIZE = 'query/LIST_SET_PAGE_SIZE';
const LIST_SET_PAGE = 'query/LIST_SET_PAGE';
const LIST_SORT = 'query/LIST_SORT';
const LIST_RESET = 'query/LIST_RESET';
const LIST_RESET_CONFIG = 'query/LIST_RESET_CONFIG';
const LIST_SET_HIDDEN = 'query/LIST_SET_HIDDEN';
const LIST_SET_QUERY = 'query/LIST_SET_QUERY'; // just text
const LIST_SET_ATTRS = 'query/LIST_SET_ATTRS';
const LIST_SET_FILTER = 'query/LIST_SET_FILTER'; // actual filter in request
const LIST_SAVE = 'query/LIST_SAVE';
const LIST_DELETE = 'query/LIST_DELETE';
const LIST_START_EXPORT = 'query/LIST_START_EXPORT';


export {
    LIST_START_QUERY,
    LIST_START_INITIAL_QUERY,
    LIST_START_EXISTING_QUERY,
    LIST_RESPONSE,
    LIST_ERROR,
    ENTITY_START_DELETE,
    LIST_SET_PAGE_SIZE,
    LIST_SET_PAGE,
    LIST_SORT,
    LIST_RESET,
    LIST_RESET_CONFIG,
    LIST_SET_HIDDEN,
    LIST_SET_QUERY,
    LIST_SET_ATTRS,
    LIST_SET_FILTER,
    LIST_SAVE,
    LIST_DELETE,
    LIST_START_EXPORT,
}

export enum SortOrder {
    Asc = 'asc',
    Desc = 'desc'
}

export interface SortCol {
    path: string;
    direction?: SortOrder;
}

export interface Response {
    totalCount: number
    attributes: string[]
    limit: number | null
    offset: number | null
    order: SortCol[]
    tuples: any[]
}

export interface PageSpec {
    offset: number | null
    limit: number | null
}

export interface Request {
    resourceName: string
    attributes: _.Dictionary<Field> // path -> Request
    order: SortCol[]
    pageSpec: PageSpec
    filter?: string
}

export interface ListState {
    local: boolean
    loading: boolean
    error: boolean
    request?: Request
    response?: Response
    hidden: boolean // show hidden fields/columns
    query: string
    name?: string
}

export interface GridEntity {
    id?: string
    name: string
    resource: string
    attributes: string
    filter?: string
    order?: string
}

export interface ListQueryAction {
    type: typeof LIST_START_QUERY
    request: Request
    local: boolean
}

export interface ListStartInitialQueryAction {
    type: typeof LIST_START_INITIAL_QUERY
    resourceName: string
    local: boolean
    search?: string
}

export interface ListExistingQueryAction {
    type: typeof LIST_START_EXISTING_QUERY
    local?: boolean
}

export interface ListResponseAction {
    type: typeof LIST_RESPONSE
    response: Response
}

export interface ListErrorAction {
    type: typeof LIST_ERROR
    error: any
}

export interface DeleteStartAction {
    type: typeof ENTITY_START_DELETE
    resourceName: string
    id: number
}

export interface ListSortAction {
    type: typeof LIST_SORT
    attr: string
    order?: SortOrder
}

export interface ListSetPageSizeAction {
    type: typeof LIST_SET_PAGE_SIZE
    size: number
}

export interface ListSetPageAction {
    type: typeof LIST_SET_PAGE
    page: number
}

export interface ListResetAction {
    type: typeof LIST_RESET
}

export interface ListResetConfigAction {
    type: typeof LIST_RESET_CONFIG
}

export interface ListSetShowHiddenAction {
    type: typeof LIST_SET_HIDDEN
    hidden: boolean
}

export interface ListSetQueryAction {
    type: typeof LIST_SET_QUERY
    query: string
}

export interface ListSetAttrsAction {
    type: typeof LIST_SET_ATTRS
    attrs: _.Dictionary<Field>
}

export interface ListSetFilterAction {
    type: typeof LIST_SET_FILTER
    filter: string
}

export interface ListSaveAction {
    type: typeof LIST_SAVE
    name: string
}

export interface ListDeleteAction {
    type: typeof LIST_DELETE
    id: string
}

export interface ListStartExportAction {
    type: typeof LIST_START_EXPORT
}

export type ListActions =
    ListQueryAction
    | ListStartInitialQueryAction
    | ListExistingQueryAction
    | ListResponseAction
    | ListErrorAction
    | ListSetPageSizeAction
    | ListSetPageAction
    | ListSortAction
    | ListResetAction
    | ListResetConfigAction
    | ListSetShowHiddenAction
    | ListSetQueryAction
    | ListSetAttrsAction
    | ListSetFilterAction
    | ListSaveAction
    | ListDeleteAction

export interface ListConf extends ResourceComp {
    type: typeof LIST
    options?: {
        add: string
        edit: string
    }
}
